import camelCase from 'lodash/camelCase'
import isPlainObject from 'lodash/isPlainObject'
import mapKeys from 'lodash/mapKeys'
import mapValues from 'lodash/mapValues'
import snakeCase from 'lodash/snakeCase'

/**
 * 스네이크 케이스 -> 카멜 케이스 변환
 */
export const toCamelCase = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(item => toCamelCase(item))
  } else if (isPlainObject(obj)) {
    return mapValues(
      mapKeys(obj, (_: any, key: any) => camelCase(key)),
      toCamelCase
    )
  }

  return obj
}

/**
 * 카멜 케이스 -> 스네이크 케이스 변환
 */
export const toSnakeCase = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(item => toSnakeCase(item))
  } else if (isPlainObject(obj)) {
    return mapValues(
      mapKeys(obj, (_: any, key: any) => snakeCase(key)),
      toSnakeCase
    )
  }

  return obj
}
